<template>
    <div class="container-fluid maintenance-kpi-container maintenance-kpi">
        <div class="row no-print">
            <div class="col-sm-6">
                <select
                    v-model="type"
                    @change="loadReport"
                    class="form-control"
                >
                    <option value="fire_alarm">
                        Fire Alarm
                    </option>
                    <option value="fire_ex">
                        Fire Extinguisher
                    </option>
                </select>
                <button
                    class="btn btn-primary"
                    @click="print"
                >
                    Print
                </button>
            </div>
            <div class="col-sm-6 text-right">
                <label for="year">Year: </label>
                <input
                    id="year"
                    type="number"
                    step="1"
                    min="2000"
                    v-model="year"
                    @change="loadReport"
                    class="form-control"
                >
            </div>
        </div>
        <div v-html="kpiHtml" />

        <div class="card no-print">
            <div class="card-body">
                <h3>Monthly Reports</h3>
                <p>You can manually resend the monthly KPI reports to a custom email address.</p>
                <div class="row">
                    <div class="col-sm-12">
                        <label for="to">Send reports to:</label>
                        <input
                            type="email"
                            v-model="to"
                            class="form-control"
                            placeholder="user@example.com"
                            :disabled="sending"
                        >
                        <button
                            class="btn btn-primary"
                            @click="sendReports"
                            :disabled="!to || sending"
                        >
                            <span v-if="!sending">Send</span>
                            <span v-else>Sending...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SettingsMixin from '../../mixins/SystemSettings';
import AuthService from '../../services/AuthService';
export default {
    mixins: [
        SettingsMixin,
    ],
    data() {
        return {
            year: window.moment().format('YYYY'),
            reminders: [],
            type: 'fire_alarm',
            currentMonth: window.moment().month(),
            kpiHtml: 'Loading...',
            to: AuthService.user.email,
            sending: false,
        };
    },

    mounted() {
        this.loadReport();
    },

    methods: {
        print() {
            window.print();
        },

        loadReport() {
            this.kpiHtml = 'Loading...';
            window.axios.get('/api/maintenance/kpiReportHtml', {params: {year: this.year, type: this.type}}).then(res => {
                this.kpiHtml = res.data;
            }).catch(err => {
                window.alert('Error: Failed to load maintenance data');
                throw err;
            })
        },

        sendReports () {
            this.sending = true;
            window.axios.post('/api/maintenance/send', {to: this.to}).then(res => {
                window.alert('KPI Reports Sent');
                console.log(res.data.output);
                this.sending = false;
            }).catch(err => {
                window.alert('Error: Failed to send reports');
                this.sending = false;
                throw err;
            });
        }
    },
}
</script>
<style lang="scss" scoped>
.form-control {
    width: auto;
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/MaintenanceKPIComponent.vue